import { useState, useEffect } from "react";
import SideMenu from "../../features/sideMenu/SideMenu";
import { useParams, useSearchParams } from "react-router-dom";
import FormStepper from "../../features/stepper/Stepper";
import { itemsProjects } from "../../constants/projects";
import { buscarTrabajosPorCriterios } from "../functions/Projects";
import "./EditProject.responsive.css";

const EditProject = ({
  API_URL,
  clients,
  projects,
  typeWorks,
  permisionarios,
  states,
}) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [proyecto, setProyecto] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const criterios = {
        id,
        nombre: null,
        puntoCarga: null,
        rpu: null,
        proyecto: null,
        cliente: null,
        permisionario: null,
        empresa: null,
        tipoTrabajo: null,
        estatus: null,
        direccion: null,
        parametro: null,
        latitude: null,
        longitude: null,
        estado: null,
      };

      buscarTrabajosPorCriterios(
        API_URL,
        criterios,
        (resultados) => {
          if (resultados.length > 0) {
            const proyecto = resultados[0];
            if (projects) {
              const proyectoCompleto = projects.find(
                (p) => p.id === proyecto.proyecto.id
              );
              if (proyectoCompleto) {
                proyecto.proyecto = proyectoCompleto;
              }
            }

            setProyecto(proyecto);
          }
        },
        (errorMsg) => {
          console.log(errorMsg);
        }
      );
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="ep-container" style={{ display: "flex", height: "100%" }}>
      <div className="ep-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProjects} />
      </div>
      <div className="ep-main">
        {proyecto && (
          <FormStepper
            clients={clients}
            projects={projects}
            typeWorks={typeWorks}
            permisionarios={permisionarios}
            edit={true}
            proyecto={proyecto}
            API_URL={API_URL}
            step={searchParams.get("step") || 0}
            newWorkCenter={searchParams.get("newWorkCenter") || false}
            editWorkCenter={searchParams.get("editWorkCenter") || false}
            states={states}
          />
        )}
      </div>
    </div>
  );
};

export default EditProject;
